/*
 * "Notify me" for sold-out variants (snippets/mist-notify-me.liquid).
 * Follows the variant picker (Dawn's variantChange event) to show the box only on sold-out variants, and posts the
 * email to Klaviyo's client back-in-stock subscription API (public site key; no private key in the browser).
 */
(() => {
  const KLAVIYO_SITE_ID = 'QxQ6yh';
  const ENDPOINT = `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${KLAVIYO_SITE_ID}`;
  const REVISION = '2026-10-15';

  const boxes = () => document.querySelectorAll('[data-mist-notify]');

  const show = (box, variant) => {
    if (!variant) {
      box.hidden = true;
      return;
    }
    const changed = String(variant.id) !== box.dataset.variantId;
    box.dataset.variantId = variant.id;
    box.hidden = !!variant.available;
    if (changed) {
      box.querySelector('[data-mist-notify-form]').hidden = false;
      const msg = box.querySelector('.mist-notify__msg');
      msg.hidden = true;
      msg.textContent = '';
    }
  };

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      boxes().forEach((box) => {
        const ids = (box.dataset.variants || '').split(',');
        if (data.variant && !ids.includes(String(data.variant.id))) return;
        show(box, data.variant);
      });
    });
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.('[data-mist-notify-form]');
    if (!form) return;
    event.preventDefault();
    const box = form.closest('[data-mist-notify]');
    const input = form.querySelector('input[type="email"]');
    const msg = box.querySelector('.mist-notify__msg');
    const email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Please enter a valid email address.';
      msg.hidden = false;
      input.focus();
      return;
    }
    const button = form.querySelector('button');
    button.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
        body: JSON.stringify({
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              channels: ['EMAIL'],
              profile: { data: { type: 'profile', attributes: { email } } },
            },
            relationships: {
              variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${box.dataset.variantId}` } },
            },
          },
        }),
      });
      if (!res.ok) throw new Error(`Klaviyo ${res.status}`);
      form.hidden = true;
      msg.textContent = "Thanks, we'll email you when it's back.";
    } catch (error) {
      console.error(error);
      msg.textContent = "Sorry, that didn't work. Please try again.";
    } finally {
      msg.hidden = false;
      button.removeAttribute('aria-busy');
    }
  });
})();
